import axiosInstance from "../../lib/axios";

export async function insertTransportPlan(payload){
    try {
      return await axiosInstance.post('MstTransPlan/InsertMstTransPlan',payload);  
    } catch (error) {
      return error;  
    }
}
export async function updateTransportPlan(payload){
    try {
        return await axiosInstance.post('MstTransPlan/UpdateMstTransPlan',payload); 
    } catch (error) {
        return error;
    }
}
export async function retriveTransportPlan(payload){
    try {
        return await axiosInstance.post('MstTransPlan/RetriveMstTransPlan',payload); 
    } catch (error) {
        return error;
    }
}
